<template>
  <div class="fixed-page">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad">
      <van-cell v-for="(item, index) in tasks" :key="index">
        <div class="task-item shadow">
          <div class="task-text">
            <div>
              <van-tag type="primary" v-if="item.frequency == 1">每日</van-tag>
              <span>{{item.title}}</span>
            </div>
            <div class="task-description">
              {{item.description}}
            </div>
          </div>
          <div class="task-todo">
            <div>+{{item.money}}元</div>
            <van-button
              :disabled="item.record_id"
              @click="handleClick(item)"
              type="primary"
              round
              size="mini">
              完成<span class="count">({{item.finish_count > item.ladder_count
                ? item.ladder_count
                : item.finish_count}}/{{item.ladder_count}})</span>
            </van-button>
          </div>
        </div>
      </van-cell>
    </van-list>
  </div>
</template>
<script>
import {
  List,
  Cell,
  Tag,
  Button,
} from 'vant';
import FixedProxy from '@/proxies/fixed';
import { judgeClient } from '@/utils/tools';
import VideoAD from '@/mixins/video-ad';

export default {
  data() {
    return {
      banners: [],
      types: [],
      activeTypeIndex: 0,
      tasks: [],
      finished: false,
      loading: false,
      totalRecordCount: 0,
      autoLoad: false,
      adReward: null,
    };
  },
  mixins: [VideoAD],
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Button.name]: Button,
  },
  watch: {
    userId() {
      this.loadTasks();
    },
  },
  computed: {
    systemInfo() {
      return this.$store.state.system.info;
    },
    userId() {
      return this.$store.state.account.info.id;
    },
    isAPP() {
      return navigator.userAgent.indexOf('Html5Plus') > -1;
    },
    clientType() {
      const platform = judgeClient();
      let type = 2;
      if (this.isAPP) {
        switch (platform) {
          case 'ios':
            type = 4;
            break;
          case 'android':
            type = 3;
            break;
          default:
            console.info(platform);
            break;
        }
      }
      return type;
    },
  },
  methods: {
    onLoad() {
      this.finished = true;
      this.loading = true;
      setTimeout(() => {
        this.loadTasks();
      }, 500);
    },
    async loadTasks() {
      const params = {
        userId: this.userId,
        client: this.clientType,
      };
      const res = await FixedProxy.getTasks(params);
      this.loading = false;
      if (!res.fail) {
        this.tasks = res.data;
        this.finished = true;
      }
    },
    async finishFixedTask() {
      const params = {
        userId: this.userId,
        taskType: 8,
      };
      const res = await FixedProxy.finish(params);
      if (res.success) {
        this.loadTasks();
      }
    },
    handleClick(item) {
      const { type, link } = item;
      switch (type) {
        case 2:
          // 群分享，在wxml里处理
          break;
        case 3:
          // 完成任务数量阶梯奖励
          this.$router.push({
            path: '/tasks',
          });
          break;
        case 4:
          // 发布任务数量阶梯奖励
          this.$router.push({
            name: 'task.add',
          });
          break;
        case 5:
          // 邀请用户数量阶梯奖励
          this.$router.push({
            name: 'invite.index',
          });
          break;
        case 6:
          // 实名认证
          this.$router.push({
            name: 'certification.index',
          });
          break;
        case 7:
          // 加入会员
          this.$router.push({
            name: 'vip.index',
          });
          break;
        case 8:
          // 观看广告
          this.rewardedVideoAd(link, this.finishFixedTask);
          break;
        default:
          this.$toast('当前版本不支持此任务');
          break;
      }
    },
  },
  mounted() {
    if (this.userId) {
      this.loadTasks();
    }
    this.autoLoad = true;
  },
};
</script>

<style lang="less">
  .fixed-page {
    .task-list {
      margin: 0;
      padding: 0 10px;
    }
    .task-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
    }
    .task-text {
      flex-grow: 1;
      margin-left: 10px;
      font-size: 16px;
    }
    .task-description {
      color: #666;
      font-size: 12px;
    }
    .task-time {
      color: #bbb;
    }
    .task-todo {
      color: #F56C6C;
      text-align: center;
      button {
        padding: 0 5px;
      }
      .count {
        opacity: .8;
      }
    }
  }
</style>
